export default __webpack_public_path__ + "static/media/heaven.4cbb6f10.png";